import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { SidePanelComponent } from '@lx/quote-tool/lite/shared/ui/components';
import { DialogBasedSelector } from '@lx/quote-tool/lite/shared/ui/directives';
import { FixedDateSelectorComponent } from '../fixed-date-selector/fixed-date-selector.component';
import { FixedDate } from '../../types';
import { SelectableField } from '@lx/quote-tool/lite/shared/types';
import { SelectorFieldContainerComponent } from '@lx/quote-tool/lite/shared/ui/components';

@Component({
  standalone: true,
  selector: 'lx-fixed-date-selector-field',
  imports: [SelectorFieldContainerComponent, SidePanelComponent, FixedDateSelectorComponent, SelectorFieldContainerComponent],
  templateUrl: './fixed-date-selector-field.component.html',
  styleUrls: ['./fixed-date-selector-field.component.scss'],
})
export class FixedDateSelectorFieldComponent extends DialogBasedSelector<FixedDate> implements OnChanges {
  @Input() label = '';
  @Input() title = '';
  @Input() fixedDates: FixedDate[] = [];
  @Input() automaticOpen = false;

  ngOnChanges({ automaticOpen }: SimpleChanges): void {
    if (automaticOpen?.currentValue) {
      this.dialogVisible = this.automaticOpen;
    }
  }

  handleSelectedFixedDate(selectedFixedDate: FixedDate) {
    this.handleSelectedValue({ value: selectedFixedDate, fromUser: true } as SelectableField<FixedDate>);
  }
}
